import { ref } from "vue";
import UsersApi from "@/common/http/UsersApi";

const PAGE_SIZE = 50;

export function useDepartmentSearch() {
  const departmentOptions = ref([]);
  const departmentLoading = ref(false);
  const hasMoreDepartments = ref(false);
  let currentQuery = "";

  async function fetchDepartments(departmentId) {
    try {
      const { data } = await UsersApi.settingsDepartments({ limit: PAGE_SIZE });
      departmentOptions.value = data.departments;
      hasMoreDepartments.value = data.departments.length >= PAGE_SIZE;

      // Ensure the currently selected department is in the list
      if (departmentId != null && !data.departments.some(d => d.id === departmentId)) {
        const { data: selected } = await UsersApi.settingsDepartments({ ids: [departmentId] });
        if (selected.departments.length) {
          departmentOptions.value = [selected.departments[0], ...data.departments];
        }
      }
    } catch {
      departmentOptions.value = [];
      hasMoreDepartments.value = false;
    }
  }

  async function remoteDepartmentSearch(query) {
    currentQuery = query || "";
    departmentLoading.value = true;
    try {
      const params = { limit: PAGE_SIZE };
      if (query) params.q = query;
      const { data } = await UsersApi.settingsDepartments(params);
      departmentOptions.value = data.departments;
      hasMoreDepartments.value = data.departments.length >= PAGE_SIZE;
    } catch {
      departmentOptions.value = [];
      hasMoreDepartments.value = false;
    } finally {
      departmentLoading.value = false;
    }
  }

  async function loadMoreDepartments() {
    if (!hasMoreDepartments.value || departmentLoading.value) return;

    departmentLoading.value = true;
    try {
      const params = { limit: PAGE_SIZE, offset: departmentOptions.value.length };
      if (currentQuery) params.q = currentQuery;
      const { data } = await UsersApi.settingsDepartments(params);
      departmentOptions.value = [...departmentOptions.value, ...data.departments];
      hasMoreDepartments.value = data.departments.length >= PAGE_SIZE;
    } catch {
      hasMoreDepartments.value = false;
    } finally {
      departmentLoading.value = false;
    }
  }

  return { departmentOptions, departmentLoading, hasMoreDepartments, fetchDepartments, remoteDepartmentSearch, loadMoreDepartments };
}
